import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './home/login/login.component';
import { LoginGuard } from './core/auth/login.guard';
import { DashComponent } from './home/dash/dash.component';
import { NotLoggedGuard } from './core/auth/not-logged.guard';
import { UserComponent } from './home/users/user.component';
import { AcessoComponent } from './home/acesso/acesso.component';
import { AcessoEditComponent } from './home/acesso/acesso-edit/acesso-edit.component';
import { DispositivosComponent } from './home/dispositivos/dispositivos.component';
import { DispositivosEditComponent } from './home/dispositivos/dispositivos-edit/dispositivos-edit.component';
import { SalasComponent } from './home/salas/salas.component';
import { SalasEditComponent } from './home/salas/salas-edit/salas-edit.component';
import { ConfigComponent } from './home/config/config.component';
import { TableSchemaResolver } from './core/schema/table-schema.resolver';
import { EmpresaComponent } from './home/empresas/empresa.component';
import { EmpresaEditComponent } from './home/empresas/empresa-edit/empresa-edit.component';
import { ReportsComponent } from './home/reports/reports.component';
import { PasswordRecoveryComponent } from './home/password-recovery/password-recovery.component';
import { AuthCallbackComponent } from './home/auth-callback/auth-callback.component';
import { RazaoContabilComponent } from './home/razao-contabil/razao-contabil.component';
import { BalanceteComponent } from './home/balancete/balancete.component';
import { AtasSociosComponent } from './home/atas-socios/atas-socios.component';
import { PendenciasComponent } from './home/pendencias/pendencias.component';
import { ContabilOutrosComponent } from './home/contabil-outros/contabil-outros.component';
import { LancamentosComponent } from './home/contabil-outros/lancamentos/lancamentos.component';
import { RegrasCteComponent } from './home/contabil-outros/regras-cte/regras-cte.component';
import { RegrasCteEditComponent } from './home/contabil-outros/regras-cte/regras-cte-edit/regras-cte-edit.component';
import { MedicosDominioComponent } from './home/medicos-dominio/medicos-dominio/medicos-dominio.component';
import { NotasFaturamentoComponent } from './home/notas-faturamento/notas-faturamento.component';
import { EmpresaSocioComponent } from './home/empresa-socio/empresa-socio.component';
import { RPAsComponent } from './home/rpas/rpas.component';
import { RPAsRelatorioComponent } from './home/rpas/relatorio/rpas-relatorio.component';
import { RPAsRelatorioPendenciasComponent } from './home/rpas/relatorio-pendencias/rpas-relatorio-pendencias.component';
import { RPAsAnalisePendenciaComponent } from './home/rpas/analise-pendencia/rpas-analise-pendencia.component';
import { CertidoesComponent } from './home/certidoes/certidoes.component';
import { CertidoesRelatorioComponent } from './home/certidoes/relatorio/certidoes-relatorio.component';
import { ProcessamentoFaturasComponent } from './home/processamento-faturas/processamento-faturas.component';
import { CertificadoDigitalComponent } from './home/certificado-digital/certificado-digital.component';
import { ChavesAcessoComponent } from './home/chaves-acesso/chaves-acesso.component';
import { ConciliacaoFornecedoresComponent } from './home/conciliacao-fornecedores/conciliacao-fornecedores.component';
import { ConvencoesSindicaisComponent } from './home/convencoes-sindicais/convencoes-sindicais.component';
import { AcumuladoresComponent } from './home/acumuladores/acumuladores.component';
import { DpFichasComponent } from './home/dp/dp-fichas/dp-fichas.component';
import { DpRubricasComponent } from './home/dp/dp-rubricas/dp-rubricas.component';
import { DpDescobrirRubricasComponent } from './home/dp/dp-rubricas/dp-descobrir-rubricas.component';
import { DpLancamentoRubricasComponent } from './home/dp/dp-lancamento-rubricas/dp-lancamento-rubricas.component';
import { RelatorioConvenioComponent } from './home/rh/relatorio-convenio/relatorio-convenio.component';
import { SimplesNacionalComponent } from './home/fiscal/simples-nacional/simples-nacional.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'password-recovery',
    component: PasswordRecoveryComponent
  },
  {
    path: 'home',
    component: DashComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'users',
    component: UserComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'access',
    component: AcessoComponent,
    resolve: { fields: TableSchemaResolver },
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'access-edit',
    component: AcessoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'access-edit/:id',
    component: AcessoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'devices',
    component: DispositivosComponent,
    resolve: { fields: TableSchemaResolver },
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'devices-edit',
    component: DispositivosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'devices-edit/:id',
    component: DispositivosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'rooms',
    component: SalasComponent,
    resolve: { fields: TableSchemaResolver },
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'rooms-edit',
    component: SalasEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'rooms-edit/:id',
    component: SalasEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'empresa',
    component: EmpresaComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'empresa-edit/:id',
    component: EmpresaEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'empresa-edit',
    component: EmpresaEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'config',
    component: ConfigComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'razao-contabil',
    component: RazaoContabilComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'balancete',
    component: BalanceteComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'atas-socios',
    component: AtasSociosComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'pendencias',
    component: PendenciasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'medicos-dominio',
    component: MedicosDominioComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'notas-faturamento',
    component: NotasFaturamentoComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'empresa-socio',
    component: EmpresaSocioComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'contabil-outros',
    component: ContabilOutrosComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'lancamentos',
    component: LancamentosComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'dp-fichas',
    component: DpFichasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'dp-rubricas',
    component: DpRubricasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'dp-descobrir-rubricas',
    component: DpDescobrirRubricasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'dp-lancamento-rubricas',
    component: DpLancamentoRubricasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'relatorio-convenio-medico',
    component: RelatorioConvenioComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'simples-nacional',
    component: SimplesNacionalComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'regras-cte',
    component: RegrasCteComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'regras-cte-edit/:id',
    component: RegrasCteEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'regras-cte-edit',
    component: RegrasCteEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'auth/callback',
    component: AuthCallbackComponent
  },
  {
    path: 'rpa',
    component: RPAsComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'rpa/relatorio',
    component: RPAsRelatorioComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'rpa/analise-pendencia',
    redirectTo: 'relatorio-pendencias',
    pathMatch: 'full'
  },
  {
    path: 'certidoes',
    component: CertidoesComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'certidoes/relatorio',
    component: CertidoesRelatorioComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'relatorio-pendencias',
    component: RPAsAnalisePendenciaComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'relatorio-pendencias/consulta',
    component: RPAsRelatorioPendenciasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'processamento-faturas',
    component: ProcessamentoFaturasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'certificado-digital',
    component: CertificadoDigitalComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'chaves-acesso',
    component: ChavesAcessoComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'conciliacao-fornecedores',
    component: ConciliacaoFornecedoresComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'convencoes-sindicais',
    component: ConvencoesSindicaisComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'acumuladores',
    component: AcumuladoresComponent,
    canActivate: [NotLoggedGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
